import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TitleService } from 'src/app/_services/title.service';

@Component({
  selector: "users-layout",
  templateUrl: "./users.layout.html",
  host: { 'class': 'tab-content' },
  styleUrls: ['./users.layout.scss']
})
export class UsersLayout implements OnInit {
  title = "cards.lexi_market_settings.lxm_settings_user.title";

  constructor(private _titleService: TitleService) {}

  public ngOnInit() {
    this._titleService.setTitle(this.title);
  }

}
